import { CopyableGuid } from "@components/CopyableText";
import React from "react";

import { DetailsList, IColumn } from "@bps/fluent-ui";
import { DATE_FORMATS, DateTime } from "@bps/date-time";
import {
  PracticeLocationExclusions,
  PracticeLocationProvider
} from "@libs/api/gateways/best-health/practice/best-health-ops-gateway.dtos";

interface ExclusionsTableProps {
  exclusions: PracticeLocationExclusions[];
}

function formatTime(offsetMinutes: number): string {
  return offsetMinutes >= 0
    ? DateTime.now()
        .startOf("day")
        .plus({ minutes: offsetMinutes })
        .toFormat("h:mm a")
    : "";
}

export const PracticeExclusionsTable: React.FC<ExclusionsTableProps> = ({
  exclusions
}) => {
  const columns: IColumn[] = [
    {
      key: "providerId",
      name: "Provider Id",
      fieldName: "providerId",
      minWidth: 310,
      maxWidth: 310,
      onRender: (item: PracticeLocationProvider) =>
        item.providerId ? <CopyableGuid value={item.providerId} /> : "N/A"
    },
    {
      key: "exclusionPeriodName",
      name: "Exclusion Period Name",
      fieldName: "exclusionPeriodName",
      minWidth: 150,
      maxWidth: 250,
      onRender: (item: PracticeLocationExclusions) =>
        item.exclusionPeriodName?.trim().length
          ? item.exclusionPeriodName
          : "N/A"
    },
    {
      key: "providerName",
      name: "Provider Name",
      fieldName: "providerName",
      minWidth: 150,
      maxWidth: 250,
      onRender: (item: PracticeLocationExclusions) =>
        item.providerName?.trim().length ? item.providerName : "N/A"
    },
    {
      key: "startDate",
      name: "Start Date",
      minWidth: 100,
      maxWidth: 150,
      onRender: (item: PracticeLocationExclusions) =>
        item.startDate?.toFormat(DATE_FORMATS.DAY_DEFAULT_FORMAT)
    },
    {
      key: "endDate",
      name: "End Date",
      minWidth: 100,
      maxWidth: 150,
      onRender: (item: PracticeLocationExclusions) =>
        item.endDate?.toFormat(DATE_FORMATS.DAY_DEFAULT_FORMAT) ?? "N/A"
    },
    {
      key: "startTime",
      name: "Start Time",
      fieldName: "startTime",
      minWidth: 100,
      maxWidth: 200,
      onRender: (item: PracticeLocationExclusions) => formatTime(item.startTime)
    },
    {
      key: "endTime",
      name: "End Time",
      fieldName: "endTime",
      minWidth: 100,
      maxWidth: 200,
      onRender: (item: PracticeLocationExclusions) => formatTime(item.endTime)
    }
  ];
  return <DetailsList columns={columns} items={exclusions} />;
};
